import { useState } from 'react';
import Header from '@/components/feature/Header';
import AdminShell from './components/AdminShell';
import type { SectionId } from './components/navConfig';
import CommandCenter from './components/CommandCenter';
import EditorialWorkspace from './components/EditorialWorkspace';
import TournamentManager from './components/TournamentManager';
import BulletinManager from './components/BulletinManager';
import MultilingualPublishing from './components/MultilingualPublishing';
import SponsorsLeads from './components/SponsorsLeads';
import RevenueOperations from './components/RevenueOperations';
import CharityFundraising from './components/CharityFundraising';
import SubscriberStats from './components/SubscriberStats';
import RegionalAnalytics from './components/RegionalAnalytics';
import LanguageAnalytics from './components/LanguageAnalytics';
import AiActivityPreview from './components/AiActivityPreview';

export default function DemoAdmin() {
  const [section, setSection] = useState<SectionId>('command-center');

  return (
    <div className="bg-background-100 text-foreground-950 min-h-screen">
      <Header />
      <AdminShell active={section} onNavigate={setSection}>
        {section === 'command-center' && <CommandCenter onGo={setSection} />}
        {section === 'editorial' && <EditorialWorkspace />}
        {section === 'tournaments' && <TournamentManager />}
        {section === 'bulletins' && <BulletinManager />}
        {section === 'multilingual' && <MultilingualPublishing />}
        {section === 'sponsors' && <SponsorsLeads />}
        {section === 'revenue' && <RevenueOperations />}
        {section === 'fundraising' && <CharityFundraising />}
        {section === 'audience' && <SubscriberStats />}
        {section === 'analytics' && <RegionalAnalytics />}
        {section === 'language' && <LanguageAnalytics />}
        {section === 'ai-activity' && <AiActivityPreview />}
      </AdminShell>
    </div>
  );
}